@layer token {
  :root {
    --n-bleed-025: calc(var(--n-scale-025) * -1);
    --n-bleed-050: calc(var(--n-scale-050) * -1);
    --n-bleed-100: calc(var(--n-scale-100) * -1);
    --n-bleed-150: calc(var(--n-scale-150) * -1);
    --n-bleed-200: calc(var(--n-scale-200) * -1);
    --n-bleed-250: calc(var(--n-scale-250) * -1);
    --n-bleed-300: calc(var(--n-scale-300) * -1);
    --n-bleed-400: calc(var(--n-scale-400) * -1);
    --n-bleed-500: calc(var(--n-scale-500) * -1);
    --n-bleed-600: calc(var(--n-scale-600) * -1);
  }
}

@layer component {
  /* MARGIN INLINE ------------------------------------------------------------ */

  .marginInline025 {
    margin-inline: var(--n-bleed-025);
  }
  .marginInline050 {
    margin-inline: var(--n-bleed-050);
  }
  .marginInline100 {
    margin-inline: var(--n-bleed-100);
  }
  .marginInline150 {
    margin-inline: var(--n-bleed-150);
  }
  .marginInline200 {
    margin-inline: var(--n-bleed-200);
  }
  .marginInline250 {
    margin-inline: var(--n-bleed-250);
  }
  .marginInline300 {
    margin-inline: var(--n-bleed-300);
  }
  .marginInline400 {
    margin-inline: var(--n-bleed-400);
  }
  .marginInline500 {
    margin-inline: var(--n-bleed-500);
  }
  .marginInline600 {
    margin-inline: var(--n-bleed-600);
  }

  /* MARGIN BLOCK ------------------------------------------------------------- */

  .marginBlock025 {
    margin-block: var(--n-bleed-025);
  }
  .marginBlock050 {
    margin-block: var(--n-bleed-050);
  }
  .marginBlock100 {
    margin-block: var(--n-bleed-100);
  }
  .marginBlock150 {
    margin-block: var(--n-bleed-150);
  }
  .marginBlock200 {
    margin-block: var(--n-bleed-200);
  }
  .marginBlock250 {
    margin-block: var(--n-bleed-250);
  }
  .marginBlock300 {
    margin-block: var(--n-bleed-300);
  }
  .marginBlock400 {
    margin-block: var(--n-bleed-400);
  }
  .marginBlock500 {
    margin-block: var(--n-bleed-500);
  }
  .marginBlock600 {
    margin-block: var(--n-bleed-600);
  }

  /* MARGIN BLOCK START ------------------------------------------------------- */

  .marginBlockStart025 {
    margin-block-start: var(--n-bleed-025);
  }
  .marginBlockStart050 {
    margin-block-start: var(--n-bleed-050);
  }
  .marginBlockStart100 {
    margin-block-start: var(--n-bleed-100);
  }
  .marginBlockStart150 {
    margin-block-start: var(--n-bleed-150);
  }
  .marginBlockStart200 {
    margin-block-start: var(--n-bleed-200);
  }
  .marginBlockStart250 {
    margin-block-start: var(--n-bleed-250);
  }
  .marginBlockStart300 {
    margin-block-start: var(--n-bleed-300);
  }
  .marginBlockStart400 {
    margin-block-start: var(--n-bleed-400);
  }
  .marginBlockStart500 {
    margin-block-start: var(--n-bleed-500);
  }
  .marginBlockStart600 {
    margin-block-start: var(--n-bleed-600);
  }

  /* MARGIN BLOCK END --------------------------------------------------------- */

  .marginBlockEnd025 {
    margin-block-end: var(--n-bleed-025);
  }
  .marginBlockEnd050 {
    margin-block-end: var(--n-bleed-050);
  }
  .marginBlockEnd100 {
    margin-block-end: var(--n-bleed-100);
  }
  .marginBlockEnd150 {
    margin-block-end: var(--n-bleed-150);
  }
  .marginBlockEnd200 {
    margin-block-end: var(--n-bleed-200);
  }
  .marginBlockEnd250 {
    margin-block-end: var(--n-bleed-250);
  }
  .marginBlockEnd300 {
    margin-block-end: var(--n-bleed-300);
  }
  .marginBlockEnd400 {
    margin-block-end: var(--n-bleed-400);
  }
  .marginBlockEnd500 {
    margin-block-end: var(--n-bleed-500);
  }
  .marginBlockEnd600 {
    margin-block-end: var(--n-bleed-600);
  }

  /* MARGIN INLINE START ------------------------------------------------------ */

  .marginInlineStart025 {
    margin-inline-start: var(--n-bleed-025);
  }
  .marginInlineStart050 {
    margin-inline-start: var(--n-bleed-050);
  }
  .marginInlineStart100 {
    margin-inline-start: var(--n-bleed-100);
  }
  .marginInlineStart150 {
    margin-inline-start: var(--n-bleed-150);
  }
  .marginInlineStart200 {
    margin-inline-start: var(--n-bleed-200);
  }
  .marginInlineStart250 {
    margin-inline-start: var(--n-bleed-250);
  }
  .marginInlineStart300 {
    margin-inline-start: var(--n-bleed-300);
  }
  .marginInlineStart400 {
    margin-inline-start: var(--n-bleed-400);
  }
  .marginInlineStart500 {
    margin-inline-start: var(--n-bleed-500);
  }
  .marginInlineStart600 {
    margin-inline-start: var(--n-bleed-600);
  }

  /* MARGIN INLINE END -------------------------------------------------------- */

  .marginInlineEnd025 {
    margin-inline-end: var(--n-bleed-025);
  }
  .marginInlineEnd050 {
    margin-inline-end: var(--n-bleed-050);
  }
  .marginInlineEnd100 {
    margin-inline-end: var(--n-bleed-100);
  }
  .marginInlineEnd150 {
    margin-inline-end: var(--n-bleed-150);
  }
  .marginInlineEnd200 {
    margin-inline-end: var(--n-bleed-200);
  }
  .marginInlineEnd250 {
    margin-inline-end: var(--n-bleed-250);
  }
  .marginInlineEnd300 {
    margin-inline-end: var(--n-bleed-300);
  }
  .marginInlineEnd400 {
    margin-inline-end: var(--n-bleed-400);
  }
  .marginInlineEnd500 {
    margin-inline-end: var(--n-bleed-500);
  }
  .marginInlineEnd600 {
    margin-inline-end: var(--n-bleed-600);
  }
}
